export default "__VITE_ASSET__DsOa6py1__"